import { Flag, Trash2 } from "lucide-react";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import TextInput from "../../components/TextInput";

const MarkerBoard = (props) => {
  const data = props.markerBoardData || {};
  const index = props.markerBoardIndex;
  const possessionIndex = props.possessionIndex;
  const path = `possessions.${possessionIndex}.marker_boards.${index}`;

  return (
    <section className="wsm-inline-editor">
      <div className="wsm-inline-editor__heading">
        <span className="wsm-inline-editor__icon"><Flag aria-hidden="true" /></span>
        <strong>Marker board {index + 1}</strong>
        <IconButton aria-label={`Remove marker board ${index + 1}`} disabled={index === 0} icon={Trash2} onClick={() => props.handleRemoveFormRow(`possessions.${possessionIndex}.marker_boards`, index, true, "marker board")} size="compact" variant="destructive" />
      </div>
      <div className="wsm-inline-editor__fields wsm-inline-editor__fields--two">
        <FormField id={`marker-board-name-${possessionIndex}-${index}`} label="Name">
          {(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`${path}.name`, event.target.value)} value={data.name || ""} />}
        </FormField>
        <FormField id={`marker-board-location-${possessionIndex}-${index}`} label="Location">
          {(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`${path}.location`, event.target.value)} value={data.location || ""} />}
        </FormField>
      </div>
    </section>
  );
};

export default MarkerBoard;
